const getMeasurementId = () => (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();

const dynamicRoutePatterns = [
  [/^\/welcome\/[^/]+$/, '/welcome/:requestId'],
  [/^\/auth\/[^/]+$/, '/auth/:requestId'],
  [/^\/review\/[^/]+$/, '/review/:requestId'],
  [/^\/kyc\/[^/]+$/, '/kyc/:requestId'],
  [/^\/onramp-checkout\/[^/]+$/, '/onramp-checkout/:requestId'],
  [/^\/transak-checkout\/[^/]+$/, '/transak-checkout/:requestId'],
  [/^\/success\/[^/]+$/, '/success/:transactionId'],
  [/^\/contacts\/[^/]+$/, '/contacts/:contactId'],
  [/^\/payment-requests\/[^/]+$/, '/payment-requests/:requestId'],
];

export function normalizePagePath(pathname) {
  const path = String(pathname || '/').split(/[?#]/, 1)[0] || '/';
  return dynamicRoutePatterns.find(([pattern]) => pattern.test(path))?.[1] || path;
}

function getGtag() {
  if (typeof window.gtag === 'function') return window.gtag;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  return window.gtag;
}

export function initializeAnalytics() {
  const measurementId = getMeasurementId();
  if (!measurementId || typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const gtag = getGtag();
  if (window.__ga4InitializedMeasurementId === measurementId) return true;

  const existingScript = document.querySelector(`script[data-ga4-measurement-id="${measurementId}"]`);
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.ga4MeasurementId = measurementId;
    document.head.appendChild(script);
  }

  gtag('js', new Date());
  gtag('config', measurementId, { send_page_view: false });
  window.__ga4InitializedMeasurementId = measurementId;
  return true;
}

export function trackEvent(name, params = {}) {
  if (!name || !initializeAnalytics()) return false;
  window.gtag('event', name, params);
  return true;
}

export function trackPageView(pathname) {
  if (!initializeAnalytics()) return false;

  window.gtag('event', 'page_view', {
    page_path: normalizePagePath(pathname || window.location.pathname),
    page_title: document.title,
  });
  return true;
}

export function setAnalyticsUserId(userId) {
  if (!initializeAnalytics()) return false;
  window.gtag('set', 'user_id', userId || null);
  return true;
}
